const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
   <style>
    .container {
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 5px;
        box-shadow: 0px 1px 10px rgb(66 66 66 / 15%);
        cursor: pointer;
        padding: 16px;
        margin: 12px 0px; 
    }
    .container .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    .container .row h3 {
        margin: 0;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #424242;
    }
    .container .show {
        display: block;
    }
    .container .hide {
        display: none;
    }
   </style>
 </template>`;

styleElement.register("faq-card-style");
